import React from "react";
import { vanryLogo } from "utils/constants";
import SocialLinks from "./SocialLinks";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="relative mt-[30px]">
      <div className="relative z-10">
        <div className="relative max-w-container mx-auto md:px-4 flex items-center flex-col md:flex-row justify-center gap-6 md:justify-between py-10 lg:pt-[52px] lg:pb-[52px]">
          <div className="flex order-3 md:order-1 flex-col laptop:flex-row text-center md:text-left">
            <p className="text-xsm md:text-sm text-dim font-normal">
              Copyright © {new Date().getFullYear()} Vanar Chain
            </p>

            <ul className="mt-3 laptop:mt-0 laptop:ml-4 laptop:pl-4 laptop:border-l-[1px] border-dim/[.32] space-x-2 md:space-x-3 xl:space-x-7">
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="text-xsm md:text-sm underline hover:no-underline duration-300 text-dim/[.84]"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div className="relative md:absolute md:left-[50%]">
            <div className="flex items-center justify-center w-[46px]">
              {vanryLogo.footer}
            </div>
          </div>

          <SocialLinks />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
